document.addEventListener("DOMContentLoaded", function () {
  // Cache elements to improve performance
  const mybutton = document.getElementById("myBtn");
  const headerbtn = document.getElementById("header-buy-now-btn-scroll");
  const footerbtn = document.getElementById("footer-buy-now-btn-scroll");
  const pdpfooter = document.getElementById("footer-buy-now-btn-scroll-product");
  const firstSection = document.querySelector("section");

  window.onscroll = function () {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
    const firstSectionBottom = firstSection ? firstSection.getBoundingClientRect().bottom : 0;

    // Button visibility logic
    if (scrollTop > 3200) {
      if (footerbtn) footerbtn.style.display = "block";
      if (mybutton) mybutton.style.display = "block";
    } else if (scrollTop > 3000) {
      if (headerbtn) headerbtn.style.display = "none";
      if (mybutton) mybutton.style.display = "block";
    } else if (scrollTop > 400) {
      if (headerbtn) headerbtn.style.display = "flex";
      if (footerbtn) footerbtn.style.display = "none";
      if (mybutton) mybutton.style.display = "block";
    } else {
      if (headerbtn) headerbtn.style.display = "none";
      if (mybutton) mybutton.style.display = "none";
    }

    // Toggle active class for footer buttons near the bottom
    if (distanceFromBottom < 700) {
      if (footerbtn) footerbtn.classList.remove("footer-buy-now-btn-scroll-active");
      if (pdpfooter) pdpfooter.classList.remove("footer-buy-now-btn-scroll-product-active");
    } else {
      if (footerbtn) footerbtn.classList.add("footer-buy-now-btn-scroll-active");
      if (pdpfooter) pdpfooter.classList.add("footer-buy-now-btn-scroll-product-active");
    }

    // Display footer when first section is scrolled out of view
    if (firstSectionBottom <= 0) {
      if (pdpfooter) pdpfooter.style.display = "block";
    } else {
      if (pdpfooter) pdpfooter.style.display = "none";
    }
  };
});

// Scroll to top function
function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, and Opera
}